module.exports = __webpack_public_path__ + "static/media/5.ddfd7438.jpg";